import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '0.5rem'
    },
    itemListDetail: {
      display: 'flex',
      color: 'gray',
      flexDirection: 'column',
      alignItems: 'center'
    },
    icon: {
      boxShadow: '3px 2px 4px -1px #0000008c',
      borderRadius: '50%',
      padding: 5,
      margin: '0 5px'
    }
  }
)
const PREFIX = 'IconsDetailsStyles'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const IconsDetailsStyles = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  IconsDetailsStyles
}
